import { Question } from '../../types';

export const questions: Question[] = [
  // CATEGORY 1: PHYSICAL BODY STRUCTURE
  {
    id: 1,
    text: "What is your natural body frame and build?",
    category: "Physical Body Structure",
    options: [
      { text: "Thin, light frame, prominent joints and veins, either very tall or very short", dosha: "vata" },
      { text: "Medium build, well-proportioned, moderate muscle development", dosha: "pitta" },
      { text: "Large frame, broad chest, well-developed muscles, tendency to be heavy", dosha: "kapha" }
    ]
  },
  {
    id: 2,
    text: "How would you describe your body weight?",
    category: "Physical Body Structure",
    options: [
      { text: "Underweight, difficulty gaining weight, weight fluctuates easily", dosha: "vata" },
      { text: "Moderate weight, gains and loses weight relatively easily", dosha: "pitta" },
      { text: "Overweight or heavy, gains weight easily, difficult to lose weight", dosha: "kapha" }
    ]
  },
  {
    id: 3,
    text: "What is the nature of your skin?",
    category: "Physical Body Structure",
    options: [
      { text: "Dry, rough, cold to touch, thin skin, prominent veins", dosha: "vata" },
      { text: "Warm, oily, soft, prone to moles and freckles, sensitive", dosha: "pitta" },
      { text: "Thick, oily, smooth, cool, lustrous, pale", dosha: "kapha" }
    ]
  },
  {
    id: 4,
    text: "How would you describe your hair?",
    category: "Physical Body Structure",
    options: [
      { text: "Dry, brittle, thin, curly or kinky, coarse", dosha: "vata" },
      { text: "Fine, soft, straight, early graying or thinning, reddish/brownish", dosha: "pitta" },
      { text: "Thick, lustrous, wavy, oily, abundant, dark", dosha: "kapha" }
    ]
  },

  // CATEGORY 2: FACIAL FEATURES
  {
    id: 5,
    text: "What are your eyes like?",
    category: "Facial Features",
    options: [
      { text: "Small, dry, active/darting, dark, sunken, dull", dosha: "vata" },
      { text: "Medium size, sharp, penetrating, green/gray/copper, sensitive to light", dosha: "pitta" },
      { text: "Large, beautiful, calm, blue/dark, thick lashes, white sclera", dosha: "kapha" }
    ]
  },
  {
    id: 6,
    text: "How are your teeth and gums?",
    category: "Facial Features",
    options: [
      { text: "Irregular, protruding, thin gums, tend to crack", dosha: "vata" },
      { text: "Medium size, sharp, yellowish, bleeding gums", dosha: "pitta" },
      { text: "Large, white, strong, healthy gums", dosha: "kapha" }
    ]
  },
  {
    id: 7,
    text: "What is your nose shape?",
    category: "Facial Features",
    options: [
      { text: "Uneven, deviated, bent or turned up", dosha: "vata" },
      { text: "Sharp, pointed, red tip", dosha: "pitta" },
      { text: "Short, rounded, button-like", dosha: "kapha" }
    ]
  },
  {
    id: 8,
    text: "How are your nails?",
    category: "Facial Features",
    options: [
      { text: "Dry, rough, brittle, break easily, ridged", dosha: "vata" },
      { text: "Sharp, flexible, pink, lustrous", dosha: "pitta" },
      { text: "Thick, oily, smooth, polished, strong", dosha: "kapha" }
    ]
  },

  // CATEGORY 3: PHYSIOLOGICAL FUNCTIONS
  {
    id: 9,
    text: "What is your appetite like?",
    category: "Physiological Functions",
    options: [
      { text: "Variable, irregular, sometimes forget to eat", dosha: "vata" },
      { text: "Strong, excessive, cannot skip meals, irritable when hungry", dosha: "pitta" },
      { text: "Slow but steady, can easily skip meals", dosha: "kapha" }
    ]
  },
  {
    id: 10,
    text: "How is your digestion?",
    category: "Physiological Functions",
    options: [
      { text: "Irregular, forms gas, bloating, sometimes constipated", dosha: "vata" },
      { text: "Quick, strong, causes burning, loose stools", dosha: "pitta" },
      { text: "Slow, prolonged, forms mucus, heavy feeling after eating", dosha: "kapha" }
    ]
  },
  {
    id: 11,
    text: "What are your bowel movements like?",
    category: "Physiological Functions",
    options: [
      { text: "Dry, hard, small quantity, irregular, tendency toward constipation", dosha: "vata" },
      { text: "Soft, oily, loose, yellowish, regular", dosha: "pitta" },
      { text: "Thick, oily, heavy, slow, pale colored", dosha: "kapha" }
    ]
  },
  {
    id: 12,
    text: "How is your sleep pattern?",
    category: "Physiological Functions",
    options: [
      { text: "Light sleeper, interrupted sleep, difficulty falling asleep, active dreams", dosha: "vata" },
      { text: "Moderate sleep, sound, may wake if too warm, intense dreams", dosha: "pitta" },
      { text: "Deep sleep, prolonged, difficulty waking up, few dreams", dosha: "kapha" }
    ]
  },
  {
    id: 13,
    text: "How much do you perspire?",
    category: "Physiological Functions",
    options: [
      { text: "Minimal sweating, even in hot weather", dosha: "vata" },
      { text: "Profuse sweating, even in moderate heat, may have strong odor", dosha: "pitta" },
      { text: "Moderate sweating, pleasant smell", dosha: "kapha" }
    ]
  },
  {
    id: 14,
    text: "What is your body temperature preference?",
    category: "Physiological Functions",
    options: [
      { text: "Always cold, prefer warmth, cold hands and feet", dosha: "vata" },
      { text: "Usually warm, prefer cool environment, warm hands and feet", dosha: "pitta" },
      { text: "Adapt well to temperatures, prefer warm and dry climate", dosha: "kapha" }
    ]
  },

  // CATEGORY 4: MENTAL AND EMOTIONAL CHARACTERISTICS
  {
    id: 15,
    text: "How would you describe your mental activity?",
    category: "Mental and Emotional Characteristics",
    options: [
      { text: "Quick mind, active, restless thoughts, easily distracted", dosha: "vata" },
      { text: "Sharp intellect, focused, decisive, good concentration", dosha: "pitta" },
      { text: "Calm mind, steady thoughts, slow but thorough thinking", dosha: "kapha" }
    ]
  },
  {
    id: 16,
    text: "What is your memory like?",
    category: "Mental and Emotional Characteristics",
    options: [
      { text: "Quick to learn, quick to forget, poor long-term memory", dosha: "vata" },
      { text: "Sharp memory, good recall, learns systematically", dosha: "pitta" },
      { text: "Slow to learn but never forgets, excellent long-term memory", dosha: "kapha" }
    ]
  },
  {
    id: 17,
    text: "How do you handle stress?",
    category: "Mental and Emotional Characteristics",
    options: [
      { text: "Become anxious, worried, fearful, nervous", dosha: "vata" },
      { text: "Become angry, irritated, critical, impatient", dosha: "pitta" },
      { text: "Remain calm, may become withdrawn, possessive, or stubborn", dosha: "kapha" }
    ]
  },
  {
    id: 18,
    text: "What are your predominant emotions?",
    category: "Mental and Emotional Characteristics",
    options: [
      { text: "Fear, anxiety, insecurity, enthusiasm, joy", dosha: "vata" },
      { text: "Anger, irritability, jealousy, ambition, courage", dosha: "pitta" },
      { text: "Love, compassion, calmness, attachment, greed", dosha: "kapha" }
    ]
  },
  {
    id: 19,
    text: "How is your decision-making?",
    category: "Mental and Emotional Characteristics",
    options: [
      { text: "Quick decisions, often change mind, indecisive", dosha: "vata" },
      { text: "Decisive, determined, stick to decisions", dosha: "pitta" },
      { text: "Slow to decide, but stick with decisions once made", dosha: "kapha" }
    ]
  },

  // CATEGORY 5: BEHAVIORAL PATTERNS
  {
    id: 20,
    text: "How do you speak?",
    category: "Behavioral Patterns",
    options: [
      { text: "Talk fast, a lot, jump between topics, voice may be hoarse", dosha: "vata" },
      { text: "Speak clearly, precisely, convincingly, moderate pace", dosha: "pitta" },
      { text: "Speak slowly, calmly, melodiously, few but meaningful words", dosha: "kapha" }
    ]
  },
  {
    id: 21,
    text: "How active are you physically?",
    category: "Behavioral Patterns",
    options: [
      { text: "Very active, restless, love movement but get tired easily", dosha: "vata" },
      { text: "Moderately active, enjoy challenges and competitive sports", dosha: "pitta" },
      { text: "Prefer low activity, relaxed, enjoy comfort and rest, slow to get started", dosha: "kapha" }
    ]
  },
  {
    id: 22,
    text: "How is your endurance?",
    category: "Behavioral Patterns",
    options: [
      { text: "Low stamina, tire quickly, variable energy throughout the day", dosha: "vata" },
      { text: "Good stamina, can push through tasks with willpower", dosha: "pitta" },
      { text: "High stamina, steady energy for prolonged time, slow to fatigue", dosha: "kapha" }
    ]
  },
  {
    id: 23,
    text: "How adaptable are you to change?",
    category: "Behavioral Patterns",
    options: [
      { text: "Highly adaptable, enjoy novelty but may become unstable", dosha: "vata" },
      { text: "Adaptable if logical, dislike irrational change", dosha: "pitta" },
      { text: "Resistant to change, value routine, take time to adjust", dosha: "kapha" }
    ]
  },
  {
    id: 24,
    text: "How are your relationships with others?",
    category: "Behavioral Patterns",
    options: [
      { text: "Many acquaintances, variable relationships, easily influenced", dosha: "vata" },
      { text: "Few close friends, straightforward, sometimes intense", dosha: "pitta" },
      { text: "Loyal, long-lasting relationships, nurturing and supportive", dosha: "kapha" }
    ]
  },
  {
    id: 25,
    text: "How do you handle work and responsibilities?",
    category: "Behavioral Patterns",
    options: [
      { text: "Start enthusiastically but may lose interest or get distracted", dosha: "vata" },
      { text: "Goal-oriented, ambitious, work with focus and intensity", dosha: "pitta" },
      { text: "Stable, reliable, consistent, may procrastinate but always finish", dosha: "kapha" }
    ]
  },

  // CATEGORY 6: SENSORY PREFERENCES & TOLERANCES
  {
    id: 26,
    text: "How do you tolerate loud sounds and bright lights?",
    category: "Sensory Preferences & Tolerances",
    options: [
      { text: "Sensitive to noise and light, may feel overwhelmed", dosha: "vata" },
      { text: "Tolerant, may enjoy some stimulation", dosha: "pitta" },
      { text: "Unbothered, slow to react, prefer a peaceful setting", dosha: "kapha" }
    ]
  },
  {
    id: 27,
    text: "How is your pain tolerance?",
    category: "Sensory Preferences & Tolerances",
    options: [
      { text: "Low tolerance, very sensitive to pain", dosha: "vata" },
      { text: "Moderate tolerance, somewhat sensitive", dosha: "pitta" },
      { text: "High pain tolerance, not easily disturbed", dosha: "kapha" }
    ]
  },
  {
    id: 28,
    text: "How is your tolerance for hunger and thirst?",
    category: "Sensory Preferences & Tolerances",
    options: [
      { text: "Variable, sometimes forget to eat or drink", dosha: "vata" },
      { text: "Strong hunger and thirst, cannot miss meals, gets irritable if delayed", dosha: "pitta" },
      { text: "Low hunger or thirst, can skip meals and still feel fine", dosha: "kapha" }
    ]
  },

  // CATEGORY 7: BODY FUNCTION TENDENCIES
  {
    id: 29,
    text: "What is your tendency regarding body odors?",
    category: "Body Function Tendencies",
    options: [
      { text: "Mild or minimal body odor", dosha: "vata" },
      { text: "Strong or pungent body odor, prone to sweating", dosha: "pitta" },
      { text: "Mild, sweet smell, usually not much body odor", dosha: "kapha" }
    ]
  },
  {
    id: 30,
    text: "How is your tendency toward allergies or illnesses?",
    category: "Body Function Tendencies",
    options: [
      { text: "Prone to nervous system issues, anxiety, constipation, insomnia", dosha: "vata" },
      { text: "Prone to inflammations, skin rashes, heartburn, fevers", dosha: "pitta" },
      { text: "Prone to colds, sinus congestion, sluggish metabolism, weight gain", dosha: "kapha" }
    ]
  },
  {
    id: 31,
    text: "How is your overall body flexibility and joint health?",
    category: "Body Function Tendencies",
    options: [
      { text: "Flexible, loose joints, prone to cracking or popping", dosha: "vata" },
      { text: "Moderate flexibility, strong joints", dosha: "pitta" },
      { text: "Stiff joints, less flexible, full and cushioned", dosha: "kapha" }
    ]
  },
  {
    id: 32,
    text: "How is your sexual drive or tendency?",
    category: "Body Function Tendencies",
    options: [
      { text: "Variable, fluctuates, sometimes low, sometimes high", dosha: "vata" },
      { text: "Strong, passionate, constant", dosha: "pitta" },
      { text: "Slow, steady, loyal, calm", dosha: "kapha" }
    ]
  },
  {
    id: 33,
    text: "How are your dreams typically?",
    category: "Body Function Tendencies",
    options: [
      { text: "Active, scattered, with flying/falling/travel, unusual stories", dosha: "vata" },
      { text: "Intense, vivid, fiery, conflict or achievement theme", dosha: "pitta" },
      { text: "Calm, romantic, with water, nature, or little content", dosha: "kapha" }
    ]
  }
];

// Export question categories for filtering
export const questionCategories = {
  physical: questions.filter(q => q.category === 'Physical Body Structure'),
  mental: questions.filter(q => q.category === 'Mental and Emotional Characteristics'),
  behavioral: questions.filter(q => q.category === 'Behavioral Patterns')
};

// Export question count by category
export const questionCounts = {
  physical: questionCategories.physical.length,
  mental: questionCategories.mental.length,
  behavioral: questionCategories.behavioral.length,
  total: questions.length
};